



































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { InputInterface } from '../types/Exa_Input'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

@Component({
    components: {
        FontAwesomeIcon
    }
})
export default class InputText extends Vue {
    @Prop() private libelle!: string
    @Prop() private description!: string
    @Prop() private value!: any
    @Prop() private data!: { min: any; max: any }
    @Prop() private ident!: any
    @Prop() private requis!: boolean
    @Prop() private disabled!: boolean
    @Prop({ default: false }) private codeRestrict!: boolean
    @Prop() mode_lecture!: boolean
    @Prop() condition!: InputInterface
    @Prop() customValidity!: string
    @Prop({ default: false }) check_validation!: boolean

    inputValidity = ''

    /** 
     * customValidityHandler 
     * Gère la validation personnalisée en définissant la validité personnalisée sur l'élément inputText. 
     * @param {None} - Aucun paramètre requis. 
     */
    @Watch('customValidity')
    customValidityHandler () {
        const input: any =  this.$refs.inputText
        input.checkValidity()
        input.setCustomValidity(this.customValidity)
    }

    @Watch('value', { immediate: true, deep:true })
    checkInput () {
        this.inputValidity = ''
        if (this.data && this.data.min > 0 && this.data.max > 0 && this.value && this.value.length > 0) {
            if (this.value.length < this.data.min) {
                this.inputValidity =  'Ce champ doit contenir un minimum de ' + this.data.min + ' charactères.'
            } else if (this.value.length > this.data.max) {
                this.inputValidity =  'Ce champ doit contenir un maximum de ' + this.data.max + ' charactères.'
            }
            this.$emit('anomalieHandler', { ident: this.ident, anomalie: this.inputValidity })
        }
    }
    

    /** 
     * codeRestrictHandler 
     * Gère la restriction de code en empêchant la saisie de caractères non autorisés. 
     * @param {any} e - L'événement de saisie. 
     */
    codeRestrictHandler (e: any) {
        if (this.codeRestrict) {
            const regPrevent = /^([._a-zA-Z1-9-]+)$/u
            const regReplace = /[^a-zA-Z1-9-]/g
            if (!RegExp(regPrevent).test(e.key)) {
                e.preventDefault()
            }
            setTimeout(() => {
                if (!RegExp(regPrevent).test(e.target.value)) {
                    e.target.value = e.target.value.replace(regReplace, '')
                }
            }, 500)
        }
    }
    
    /** 
     * inputHandler 
     * Gère la saisie de l'entrée en émettant un événement avec l'identifiant et la valeur correspondants. 
     * @param {any} e - L'événement de saisie. 
     */
    inputHandler(e: any) {
        this.inputValidity = ''
        if (this.data && this.data.min > 0 && this.data.max > 0 && e.target.value && e.target.value.length > 0) {
            if (e.target.value.length < this.data.min) {
                this.inputValidity =  'Ce champ doit contenir un minimum de ' + this.data.min + ' charactères.'
            } else if (e.target.value.length > this.data.max) {
                this.inputValidity =  'Ce champ doit contenir un maximum de ' + this.data.max + ' charactères.'
            }
            this.$emit('anomalieHandler', { ident: this.ident, anomalie: this.inputValidity })
        }
        this.$emit('input', { ident: this.ident, value: e.target.value })
    }
}
